'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color2 = require('color');

var _color3 = _interopRequireDefault(_color2);

var _reactackleCore = require('reactackle-core');

var _theme = require('../../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = {
  spacing: _theme2.default.gutter,
  label: {
    fontSize: function fontSize(_ref) {
      var _fontSize = _ref.fontSize;
      return _fontSize[-2];
    },
    lineHeight: 1,
    textTransform: 'none',
    fontWeight: function fontWeight(_ref2) {
      var _fontWeight = _ref2.fontWeight;
      return _fontWeight.normal;
    },
    marginBottom: _reactackleCore.baseModule,
    color: function color(_ref3) {
      var _color = _ref3.color;
      return (0, _color3.default)(_color.black).lighten(0.54);
    },
    focus: {
      color: _theme2.default.themeColor
    },
    disabled: {
      color: function color(_ref4) {
        var fontColor = _ref4.fontColor;
        return fontColor.medium;
      }
    }
  }
};